import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export function ProtectedRoute({ children }) {
  const { isAuthenticated, loading, token } = useAuth();
  const location = useLocation();
  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;
  if (!isAuthenticated && !token) return <Navigate to="/login" replace state={{ from: location }} />;
  return children;
}
